import React, { useCallback, useEffect } from 'react'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import transitioner from '@mediatool/mt-frontend/web/transitioner'
import { ForgotPasswordForm, ResetPasswordForm, SecurityRequirementsForEnforcedUser } from '@mediatool/settings-frontend'
import { LoginForm, LoginSSOForm, QuickLogin } from '@mediatool/auth-frontend'
import { CamphouseLogoBox } from '../components/camphouse-logo'
import { usePathError } from '../hooks'

import conf from '../../mt-conf'

const getLoginPath = () => {
  const loginMethod = localStorage.getItem('loginMethod') ?? 'credentials'
  return loginMethod === 'sso' ? '/sso' : '/login'
}
const WantedPathRedirect = () => {
  const history = useHistory()
  useEffect(() => {
    const wantedURL = transitioner.getPathWithQuery().substring(1)
    history.replace(`${getLoginPath()}?wantedURL=${encodeURIComponent(wantedURL)}`)
  }, [])

  return null
}
const LoginRedirect = () => {
  const history = useHistory()
  return <Redirect to={ { ...history.location, pathname: getLoginPath() } } />
}

const LoginContainer = () => {
  const history = useHistory()
  usePathError()

  const handleBackToLogin = useCallback(() => {
    history.replace({
      pathname: '/login',
      state: {},
    })
  }, [ history ])

  const handleResetPasswordSuccess = useCallback(() => {
    history.replace('/login')
  }, [ history ])

  return (
    <div className="page">
      <div className="login-image login-image--top" />
      <div className="login-image login-image--bottom-left" />
      <div className="login-image login-image--bottom-right" />
      <div className="login">
        <div className="page__right-col">
          <CamphouseLogoBox />
          <Switch>
            <Route exact={ true } path="/" component={ LoginRedirect } />
            <Route path="/forgotpassword" render={ () => <ForgotPasswordForm onBackToLogin={ handleBackToLogin } /> } />
            <Route
              path="/resetpassword/:resetCode"
              render={ ({ match }) => (
                <ResetPasswordForm
                  resetCode={ match.params.resetCode }
                  onBackToLogin={ handleBackToLogin }
                  onSuccess={ handleResetPasswordSuccess }
                />
              ) }
            />
            <Route path="/login" render={ () => <LoginForm quickLogin={ conf.quickLogin } /> } />
            <Route path="/sso" component={ LoginSSOForm } />
            <Route
              path="/securityrequirements"
              render={ ({ location }) => (
                location.state?.email
                  ? (
                    <SecurityRequirementsForEnforcedUser
                      email={ location.state.email }
                      authFlowToken={ location.state.authFlowToken }
                      requiredActions={ location.state.requiredActions }
                      nextAction={ location.state.nextAction }
                      passwordComposition={ location.state.passwordComposition }
                    />
                  )
                  : <Redirect to="/login" />
              ) }
            />
            { conf.quickLogin && <Route path="/quicklogin" component={ QuickLogin } /> }
            <Route component={ WantedPathRedirect } />
          </Switch>
        </div>
      </div>
    </div>
  )
}

export default LoginContainer
